import { createSelector } from "@reduxjs/toolkit";

import { ACTIVE, INACTIVE } from "../../consts/driverDetails";
import { SECTION_SORT_TYPES, SORT_ORDERS } from "../../consts/sorters";

import { sectionsSorters } from "../../utils/sorters";

import {
  sectionsSorterSelector,
  sortOrderSelector,
} from "../sorters/selectors";

export const sectionManagementLoadingSelector = (state) =>
  state.sectionManagement.loading;
export const sectionViewSelector = (state) => state.sectionManagement.view;
export const isRemovingSectionSelector = (state) =>
  state.sectionManagement.isRemovingSection;

export const sectionsSelector = (state) => state.sectionManagement.sections;
export const editSectionsSelector = (state) =>
  state.sectionManagement.editSections;
export const sectionSelector = (sectionCode) => (state) =>
  state.sectionManagement.sections.find(
    (section) => section.sectionCode === sectionCode
  );

export const sectionEditModeSelector = (state) =>
  !!state.sectionManagement.sectionEdit;
export const sectionEditSelector = (state) =>
  state.sectionManagement.sectionEdit;
export const sectionEditCopySelector = (state) =>
  state.sectionManagement.sectionEditCopy;
export const sectionEditCodeSelector = (state) =>
  sectionEditSelector(state)?.sectionCode || null;
export const isSectionEditValidSelector = (state) =>
  state.sectionManagement.isSectionEditValid;

export const sectionOptionsSelector = createSelector(
  sectionsSelector,
  editSectionsSelector,
  (sections, editSections) => {
    if (!sections && !editSections) return [];
    return (editSections || sections).map(({ sectionCode, sectionName }) => {
      return {
        value: sectionName,
        sectionCode,
      };
    });
  }
);

export const sortedSectionListSelector = createSelector(
  sectionsSelector,
  editSectionsSelector,
  sortOrderSelector,
  sectionsSorterSelector,
  (sections, editSections, sortOrder, sorter) => {
    const sectionNameSorter = sectionsSorters[SECTION_SORT_TYPES.SECTION_NAME];
    const sortedSections = [...(editSections || sections)].sort((a, b) =>
      sectionNameSorter({ section: a }, { section: b })
    );

    if (sorter === sectionNameSorter && sortOrder === SORT_ORDERS.DESC)
      return sortedSections;
    else
      return sortedSections.sort((a, b) =>
        sorter({ section: a }, { section: b })
      );
  }
);

export const sectionListSelector = createSelector(
  sectionViewSelector,
  sortedSectionListSelector,
  (view, section) => {
    switch (view) {
      case ACTIVE:
        return section.filter((section) => section.isActive);
      case INACTIVE:
        return section.filter((section) => !section.isActive);
      default:
        return section;
    }
  }
);
